export const siteConfig = {
  name: '哥布林的洞窟',
  tagline: '探索黑暗地下世界的终极指南',
  description: '哥布林的洞窟是一个充满神秘与危险的地下冒险世界。我们提供最全面的游戏攻略、角色解析、地图探索指南和剧情深度解读，助你在黑暗洞穴中生存并称霸。',
  url: 'https://goblin-cave-guide.readdy.site',
  logo: '哥布林的洞窟',
  email: 'contact@goblin-cave-guide.readdy.site',
  social: {
    weibo: 'https://weibo.com/goblincave',
    bilibili: 'https://space.bilibili.com/goblincave',
  },
  navItems: [
    { label: '首页', href: '/' },
    { label: '新手攻略', href: '/category/beginner-guide' },
    { label: '角色介绍', href: '/category/characters' },
    { label: '剧情解析', href: '/category/story' },
    { label: '地图探索', href: '/category/map-exploration' },
    { label: '关于我们', href: '/about' },
  ],
};